import * as React from 'react'
import { ReactElement } from 'react'
import { LineItemProps } from './LineItem'
import { TravelListItemDto } from '../../../../../config/registrationConfig'
import { Stack } from '@fluentui/react'
import { Badge, Text } from '@fluentui/react-components'
import { MoneyRegular, VehicleCarProfileRegular } from '@fluentui/react-icons'
import MoneyText from '../../../../Text/Currency/MoneyText'
import DistanceText from '../../../../Text/Distance/DistanceText'
import PersonAvatar from '../../../../PersonAvatar'
import FormattedDateBadge from '../../../../Date/FormattedDateBadge'
import useUsers from '../../../../../hooks/useUsers'

export default function TravelLineItem({ lineItem, entity, findQuantity }: LineItemProps<TravelListItemDto>): ReactElement {
    const { getUserById } = useUsers()

    const travelItem: TravelListItemDto =
        findQuantity(lineItem?.entityId ?? entity?.id)?.map(quantity => ({
            ...entity,
            id: lineItem?.entityId ?? entity?.id,
            distance: quantity.amount,
            rate: { amount: quantity.rate, currency: entity?.rate.currency || 'EUR' },
            description: quantity.description,
            date: quantity.date,
            user: getUserById(quantity.user),
        }))?.[0] || entity

    return (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 's1' }}>
            <PersonAvatar name={travelItem?.user?.fullName} color={entity ? 'colorful' : 'neutral'} />

            <Stack horizontal={false} verticalAlign="center" tokens={{ childrenGap: 's2 s1', padding: 's2 0' }} wrap>
                <Text strikethrough={!entity}>{travelItem?.description}</Text>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <FormattedDateBadge date={travelItem?.date} />
                    <Badge size="medium" icon={<VehicleCarProfileRegular />} appearance="tint">
                        <DistanceText value={travelItem?.distance} />
                    </Badge>
                    <Badge size="medium" icon={<MoneyRegular />} appearance="tint">
                        <MoneyText value={travelItem?.rate} textProps={{ size: 200 }} />
                    </Badge>
                </Stack>
            </Stack>
        </Stack>
    )
}
